/*
 * pl-predictive-search.js — PureLink update-safe predictive-search customization.
 *
 * WHY: The Impact theme's <predictive-search> element (in the vendor bundle theme.js)
 * builds its /search/suggest request WITHOUT a `resources[options][fields]` param, so
 * Shopify only matches the DEFAULT fields (title, product_type, variants.title, vendor).
 * That means product TAGS and variant SKUs are NOT searched in the instant dropdown, so
 * model-number queries like "MVS-21" never appear as you type (they only show on Enter /
 * full search). Editing theme.js works but gets wiped on every theme update.
 *
 * HOW: theme.js fetches via cachedFetch() -> window.fetch(). We wrap window.fetch and,
 * for predictive-search requests only, append the fields param (tag + variants.sku). This
 * lives in its own asset file, so a theme-version update never touches it — only the one
 * <script> include line in layout/theme.liquid needs re-adding (same pattern as
 * pl-custom.css / pl-spec-tables.js). Fails open: any error leaves fetch untouched.
 */
(function () {
  "use strict";

  var FIELDS = "title,product_type,variants.title,vendor,tag,variants.sku";
  var MARKER = "resources[options][fields]";

  if (typeof window.fetch !== "function" || window.__plPredictiveSearchPatched) {
    return;
  }
  window.__plPredictiveSearchPatched = true;

  var nativeFetch = window.fetch;

  function withFields(url) {
    // Only touch predictive-search requests that don't already specify fields.
    if (url.indexOf("/search/suggest") === -1 || url.indexOf(MARKER) !== -1) {
      return url;
    }
    var sep = url.indexOf("?") === -1 ? "?" : "&";
    return url + sep + MARKER + "=" + FIELDS;
  }

  window.fetch = function (input, init) {
    try {
      if (typeof input === "string") {
        input = withFields(input);
      } else if (input && typeof input.url === "string") {
        var newUrl = withFields(input.url);
        if (newUrl !== input.url) {
          input = new Request(newUrl, input);
        }
      }
    } catch (e) {
      /* fail open — never break site fetches over a search tweak */
    }
    return nativeFetch.call(this, input, init);
  };
})();
